import { render, staticRenderFns } from "./lecturenotes.vue?vue&type=template&id=ba9365a4&scoped=true&"
import script from "./lecturenotes.vue?vue&type=script&lang=js&"
export * from "./lecturenotes.vue?vue&type=script&lang=js&"
import style0 from "./lecturenotes.vue?vue&type=style&index=0&id=ba9365a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9365a4",
  null
  
)

export default component.exports